import { Alpine } from '../../core/alpine-core.js';

import { apiFetch } from '../api.js';

import {

  canManageTournamentDoc,

  canDeleteTournamentDoc,

  canEndTournamentSessionDoc,

} from './tournament-access.js';



function phaseLabel(ph) {

  const m = {

    draft: 'Draft',

    registration: 'Registration',

    drawn: 'Draw published',

    in_progress: 'In progress',

    completed: 'Ended',

  };

  return m[String(ph || '')] || ph || '—';

}



Alpine.data('tournamentsListPage', () => ({

  loading: true,

  error: '',

  items: [],

  busyId: '',



  canCreate() {
    const s = this.$store?.session;
    return !!s?.canCreateTournament || !!s?.isPlayerPortalSlim;
  },



  canManageRow(row) {

    return canManageTournamentDoc(row, this.$store?.session?.me);

  },



  canDeleteRow(row) {

    return canDeleteTournamentDoc(row, this.$store?.session?.me);

  },



  canEndRow(row) {

    return canEndTournamentSessionDoc(row, this.$store?.session?.me);

  },



  rowPhaseLabel(row) {

    return phaseLabel(row?.phase);

  },



  async init() {

    this.loading = true;

    this.error = '';

    try {

      const res = await apiFetch('/tournaments');

      const data = await res.json().catch(() => ({}));

      if (!res.ok || data.ok === false) throw new Error(data.message || data.error || 'Failed to load tournaments');

      this.items = Array.isArray(data.items) ? data.items : [];

    } catch (e) {

      this.error = e.message || 'Failed to load tournaments';

    } finally {

      this.loading = false;

    }

  },



  async deleteRow(row) {

    const id = String(row?.id || '').trim();

    if (!id || !this.canDeleteRow(row)) return;

    const title = row?.title || 'this tournament';

    if (!globalThis.confirm(`Delete "${title}"? This cannot be undone.`)) return;

    this.busyId = id;

    try {

      const res = await apiFetch(`/tournaments/${encodeURIComponent(id)}`, { method: 'DELETE' });

      const data = await res.json().catch(() => ({}));

      if (!res.ok || data.ok === false) throw new Error(data.message || data.error || 'Delete failed');

      this.items = this.items.filter((r) => String(r.id) !== id);

      this.$store?.toastr?.success?.('Tournament deleted');

    } catch (e) {

      this.$store?.toastr?.error?.(e.message || 'Delete failed');

    } finally {

      this.busyId = '';

    }

  },



  async endRow(row) {

    const id = String(row?.id || '').trim();

    if (!id || !this.canEndRow(row)) return;

    const title = row?.title || 'this tournament';

    if (!globalThis.confirm(`End "${title}" now?`)) return;

    this.busyId = id;

    try {

      const res = await apiFetch(`/tournaments/${encodeURIComponent(id)}/end`, { method: 'POST', body: {} });

      const data = await res.json().catch(() => ({}));

      if (!res.ok || data.ok === false) throw new Error(data.message || data.error || 'Could not end tournament');

      const next = data.tournament;

      if (next) {

        this.items = this.items.map((r) => (String(r.id) === id ? { ...r, ...next } : r));

      }

      this.$store?.toastr?.success?.('Tournament ended');

    } catch (e) {

      this.$store?.toastr?.error?.(e.message || 'Could not end tournament');

    } finally {

      this.busyId = '';

    }

  },

}));


